import React, { Fragment, ReactElement, ReactNode, useRef, useState } from 'react';

import Buttons from 'components/Buttons';
import DropDown from '@components/FormFields/DropDown';

type ButtonProps = Parameters<typeof Buttons>[0];

type Props = ButtonProps & {
  id?: string;
  menuItems: {
    disabled?: boolean;
    iconBefore: ReactElement;
    onClick: () => void;
    title: string;
  }[];
  children?: ReactNode;
  onClick?: () => void;
  onClose?: () => void;
  isWidthFixed?: boolean;
};

function MenuButton({
  id,
  menuItems,
  children,
  onClick,
  onClose,
  isWidthFixed,
  ...restProps
}: Props): ReactElement {
  const menuWrapperEl = useRef<HTMLButtonElement>(null);
  const [isDropDownShown, setIsDropDownShown] = useState(false);

  const handleOpen = (): void => {
    onClick?.();
    setIsDropDownShown(true);
  };

  const handleClose = (): void => {
    onClose?.();
    setIsDropDownShown(false);
  };

  return (
    <Fragment>
      <Buttons {...restProps} onClick={handleOpen} ref={menuWrapperEl}>
        {children}
      </Buttons>
      {isDropDownShown && menuWrapperEl?.current && (
        <DropDown
          id={id}
          itemHeight={48}
          menuItems={menuItems}
          withCloseOnSelect={true}
          repositionOnscroll={true}
          handleClose={handleClose}
          isWidthFixed={isWidthFixed}
          menuWrapperEl={menuWrapperEl?.current}
        />
      )}
    </Fragment>
  );
}

export default MenuButton;
